import { useState } from 'react';
import { apiURL } from '../../consts/URLs';
import { SHIPPINGRULES } from '../endpointList';
import { fetchRequest, getOptions } from '../utils';
import { getCookie } from '../../utils/handleCookie';
import { cookieName } from '../../consts/cookie';

export interface Category {
    name: string;
    ordering: string;
}

const token = getCookie(cookieName.token);

const useShippingRules = () => {
    const [getShippingRulesResponse, setGetShippingRulesResponse] = useState<any>();
    const [getShippingRulesResult, setGetShippingRulesResult] = useState<any>();

    const [createShippingRulesResponse, createGetShippingRulesResponse] = useState<any>();
    const [createShippingRulesResult, createGetShippingRulesResult] = useState<any>();

    const [deleteShippingRulesResponse, setDeleteShippingRulesResponse] = useState<any>();
    const [deleteShippingRulesResult, setDeleteShippingRulesResult] = useState<any>();

    const [updateShippingRulesResponse, setUpdateShippingRulesResponse] = useState<any>();
    const [updateShippingRulesResult, setUpdateShippingRulesResult] = useState<any>();

    const getShippingRules = () => {
        const url = `${apiURL}/${SHIPPINGRULES}`;
        const options = getOptions({ method: 'GET', token: token });
        fetchRequest(url, options, setGetShippingRulesResponse, setGetShippingRulesResult);
    };

    const createShippingRule = (obj: any) => {
        const url = `${apiURL}/${SHIPPINGRULES}?name=${encodeURI(obj.name)}&min_waist=${obj.min_waist}&max_waist=${obj.max_waist}`;
        const options = getOptions({ method: 'POST', token: token });
        fetchRequest(url, options, createGetShippingRulesResponse, createGetShippingRulesResult);
    };

    const deleteShippingRule = (id: number) => {
        const url = `${apiURL}/${SHIPPINGRULES}/${id}/delete`;
        const options = getOptions({ method: 'DELETE', token: token });
        fetchRequest(url, options, setDeleteShippingRulesResponse, setDeleteShippingRulesResult);
    };

    const updateShippingRule = (obj: any) => {
        const url = `${apiURL}/${SHIPPINGRULES}/${obj.id}?name=${encodeURI(obj.name)}`;
        const options = getOptions({ method: 'PUT', token: token });
        fetchRequest(url, options, setUpdateShippingRulesResponse, setUpdateShippingRulesResult);
    };

    const RESPONSES = {
        getShippingRulesResponse,
        createShippingRulesResponse,
        deleteShippingRulesResponse,
        updateShippingRulesResponse,
    };

    const RESULTS = {
        getShippingRulesResult,
        createShippingRulesResult,
        deleteShippingRulesResult,
        updateShippingRulesResult,
    };

    const CTAs = {
        getShippingRules,
        createShippingRule,
        deleteShippingRule,
        updateShippingRule,
    };

    return { RESPONSES, RESULTS, CTAs };
};
export default useShippingRules;
